import {
  Component,
  input,
  OnChanges,
  output,
  signal,
  SimpleChanges,
} from '@angular/core';
import { images } from 'src/images';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss'],
  imports: [NgClass],
})
export class InputSearchComponent implements OnChanges {
  readonly searchValue = input<string>('');
  interalSearchValue = signal(this.searchValue());
  readonly placeholder = input<string>('');
  readonly width = input<string>('auto');
  readonly style = input<string>('primary');
  readonly compact = input<boolean>(false);
  readonly submitEventEmitter = output<string>();
  readonly valueChangeEventEmitter = output<string>();

  public images = images;

  ngOnChanges(changes: SimpleChanges): void {
    this.interalSearchValue.set(this.searchValue());
  }

  handleEnter(event: any) {
    this.submitEventEmitter.emit(event.target.value);
  }

  handleChange(event: any) {
    this.interalSearchValue.set(event.target.value);
    this.valueChangeEventEmitter.emit(event.target.value);
    if (event.target.value === '') this.onClear();
  }

  onClear() {
    this.interalSearchValue.set('');
    this.submitEventEmitter.emit('');
  }
}
